module.exports = "/_next/static/images/BargeL-940d79dd5d728bba2c553e12b931231f.png";